import { connect } from 'react-redux';
import DownloadHistory from '../components/DownloadHistory/DownloadHistory';
import * as actions from '../redux/actions/DownloadHistory';
import { getUser } from '../redux/actions/AccountSetting';
import { initializeMessage } from '../redux/actions/Common';
import { push } from 'react-router-redux';

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  downloadHistory: state.downloadHistory.downloadHistory,
  pageInfo: state.downloadHistory.pageInfo,
  isLoading: state.downloadHistory.isLoading,
  detail: state.downloadHistory.detail,
  detailPageInfo: state.downloadHistory.detailPageInfo,
  isLoadingDetail: state.downloadHistory.isLoadingDetail,
  overview: state.downloadHistory.overview,
  isLoadingOverview: state.downloadHistory.isLoadingOverview,
  message: state.downloadHistory.message,
  errorMessage: state.downloadHistory.errorMessage,
})

const mapDispatchToProps = dispatch => ({
  getDownloadHistory(data) {
    dispatch(actions.getDownloadHistory(data))
  },

  getDownloadHistoryDetail(instructedAt, ownershipUserId, page, perPage) {
    dispatch(actions.getDownloadHistoryDetail(instructedAt, ownershipUserId, page, perPage))
  },

  getDownloadHistoryOverview(data) {
    dispatch(actions.getDownloadHistoryOverview(data))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  initializeMessage() {
    dispatch(initializeMessage());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadHistory);



// WEBPACK FOOTER //
// ./src/containers/DownloadHistory.js